<div class="comparison-grid expanded-mode"
     data-test="reinsurance-comparison-grid"
     [formGroup]="form()"
>

  <div formGroupName="share">
    <albert-input class="origami-field"
                  controlName="externalValue"
                  data-test="external-share"
                  groupName="share"
                  inputId="ext_share"
                  label="Reinsurance - Share (%)"
                  [disabled]="true"
    />
  </div>
  <div class="override-cell"
       formGroupName="share"
  >
    <albert-override-wrapper data-test="override-wrapper-share"
                             tooltipLabel="Reinsurance - Share (%)"
                             [disabled]="!canEdit()"
                             [isVisible]="isFieldVisible('share')"
                             (visibilityChange)="toggleField('share')"
    >
      <albert-inputnumber controlName="localValue"
                          data-test="override-share"
                          groupName="share"
                          inputId="loc_share"
                          label="Reinsurance - Share (%)"
                          [disabled]="!canEdit()"
                          [fractionDigits]="2"
                          [maxValue]="100"
                          [minValue]="0"
                          [showButtons]="true"
      />
    </albert-override-wrapper>
  </div>

  <div formGroupName="frontingCompany">
    <albert-input class="origami-field"
                  controlName="externalValue"
                  data-test="external-frontingCompany"
                  groupName="frontingCompany"
                  inputId="ext_fronting"
                  label="Reinsurance - Fronting Company"
                  [disabled]="true"
    />
  </div>
  <div class="override-cell"
       formGroupName="frontingCompany"
  >
    <albert-override-wrapper data-test="override-wrapper-frontingCompany"
                             tooltipLabel="Reinsurance - Fronting Company"
                             [disabled]="!canEdit()"
                             [isVisible]="isFieldVisible('frontingCompany')"
                             (visibilityChange)="toggleField('frontingCompany')"
    >
      <albert-select controlName="localValue"
                     data-test="override-frontingCompany"
                     groupName="frontingCompany"
                     inputId="loc_fronting"
                     label="Reinsurance - Fronting Company"
                     optionLabel="company"
                     optionValue="company"
                     [disabled]="!canEdit()"
                     [filter]="true"
                     [options]="frontingCompanyOptions()"
                     (filterEvent)="onFrontingCompanyFilter($event)"
                     (showEvent)="onFrontingCompanyShow()"
      />
    </albert-override-wrapper>
  </div>

  <div>
  </div>
  <div class="override-cell"
       formGroupName="additionalInfoContent"
  >
    <div class="field-group h-full">
      <albert-checkbox controlName="checked"
                       data-test="override-hasAdditionalInfo"
                       groupName="additionalInfoContent"
                       inputId="loc_hasAdditionalInfo"
                       label="Reinsurance Order Additional Information"
                       [disabled]="!canEdit()"
      />
    </div>
  </div>


  @if (hasAdditionalInfoChecked()) {
    <div>
    </div>
    <div class="override-cell"
         data-test="override-additionalInfoContent-cell"
         formGroupName="additionalInfoContent"
    >
      <albert-textarea controlName="localValue"
                       data-test="override-additionalInfoContent-text"
                       groupName="additionalInfoContent"
                       inputId="loc_additionalInfoContent"
                       label="Additional Information (Content)"
                       [disabled]="!canEdit()"
                       [rows]="5"
      />
    </div>
  }

</div>
